module.exports = __webpack_public_path__ + "static/media/logo-nsca.2236f763.png";